module.exports = __webpack_public_path__ + "static/media/reject.dfc275b5.svg";